import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * SectionTitle: section heading with optional right-aligned meta text,
 * e.g. "This stop" / "2 of 5 done", "Tools".
 * Props: title (string), meta (string), style
 */
const SectionTitle = ({ title, meta, style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[styles.row, style]}>
			<Text style={styles.title} accessibilityRole="header">{title}</Text>
			{Boolean(meta) && <Text style={styles.meta}>{meta}</Text>}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'baseline',
		justifyContent: 'space-between',
		gap: space.md,
	},
	title: {
		...type.sectionTitle,
		color: colors.text,
		flexShrink: 1,
	},
	meta: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default SectionTitle;
